import LegalEntityMeasurementsBlock from "../components/blocks/LegalEntityMeasurementsBlock";

const LegalEntityMeasurementOverview = () => {

    return (<>
        <LegalEntityMeasurementsBlock/>
    </>)
}
export default LegalEntityMeasurementOverview
